"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
exports.default = (function (projectSecurer) {
    var isPartiallyAccepted = function (project) {
        if (project.status && project.status.length) {
            var hasPartialData = void 0;
            if (project.partialAcceptanceData && lodash_1.default.keys(project.partialAcceptanceData).length > 0) {
                hasPartialData = true;
            }
            else {
                hasPartialData = false;
            }
            return hasPartialData && project.status === "live";
        }
        else {
            return false;
        }
    };
    var isPending = function (project) {
        return project.status === "live" && project.hasAcceptEnabled;
    };
    return function (project) {
        if (project.hasTemplateChildren) {
            return "blueprint";
        }
        else if (["accepted", "disabled"].includes(project.status)) {
            return project.status;
        }
        else if (!projectSecurer.isWithinTimeLimit(project.links[0])) {
            return "time limit";
        }
        else if (!projectSecurer.isWithinViewLimit(project.links[0])) {
            return "view limit";
        }
        else if (isPartiallyAccepted(project)) {
            return "partially accepted";
        }
        else if (isPending(project)) {
            return "pending";
        }
        else {
            return project.status || "draft";
        }
    };
});
